import React from "react";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <p className="footer-line">
        © {year} Mohamed Ansaar · built as a model card · made with{" "}
        <span className="footer-heart">❤</span> &amp; Python
      </p>
      <p className="footer-sub">
        last commit: today · <span className="glow-name">ANSAAR</span>
      </p>
    </footer>
  );
};

export default Footer;